import React, { useState } from "react";
import "./MultiRowCarousel.css";
import AddEffortButton from "../ActionPlans/AddEffortButton";
import { useNavigate } from "react-router-dom";

const MultiRowCarousel = ({
  items,
  rowsPerSlide = 2,
  itemsPerRow = 3,
  CustomButtonGroup,
  renderItem,
  containerClassName = "",
  itemClassName = "",
  className,
  newName,
  setNewName,
  handleSave,
  link,
  // onEffortSelect,
}) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const navigate = useNavigate();
  const itemsPerSlide = rowsPerSlide * itemsPerRow;

  const handleItemClick = (item) => {
    // if (onEffortSelect) {
    //   onEffortSelect(item);
    // }
    navigate(link);
  };

  const createSlides = (items) => {
    const slides = [];

    const allItems = [...items];

    // Add the button placeholder as the last item
    className && allItems.push({ isAddButton: true });

    for (let i = 0; i < allItems.length; i += itemsPerSlide) {
      const slideItems = allItems.slice(i, i + itemsPerSlide);
      const rows = [];

      for (let j = 0; j < slideItems.length; j += itemsPerRow) {
        rows.push(slideItems.slice(j, j + itemsPerRow));
      }
      slides.push(rows);
    }
    return slides;
  };

  const slides = createSlides(items);

  const handleNext = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const handlePrevious = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  return (
    <div className={`carousel-wrapper ${containerClassName}`}>
      <div className="carousel-container">
        <div
          className="carousel-track"
          style={{
            transform: `translateX(-${currentSlide * 100}%)`,
          }}
        >
          {slides.map((slide, slideIndex) => (
            <div key={`slide-${slideIndex}`} className="carousel-slide">
              {slide.map((row, rowIndex) => (
                <div
                  key={`row-${slideIndex}-${rowIndex}`}
                  className="carousel-row"
                >
                  {row.map((item, itemIndex) => (
                    <div
                      key={`item-${slideIndex}-${rowIndex}-${itemIndex}`}
                      className={`carousel-item ${itemClassName}`}
                    >
                      {item.isAddButton ? (
                        <AddEffortButton
                          className={className}
                          newName={newName}
                          setNewName={setNewName}
                          handleSave={handleSave}
                        />
                      ) : renderItem ? (
                        renderItem(item)
                      ) : (
                        <div
                          className="default-item"
                          onClick={() => handleItemClick(item)}
                        >
                          <h4>{item.name}</h4>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
      {CustomButtonGroup && items.length >= 6 && (
        <CustomButtonGroup onNext={handleNext} onPrevious={handlePrevious} />
      )}
    </div>
  );
};

export default MultiRowCarousel;
